import {
  Button,
  DialogActions,
  DialogContent,
  Icons,
  Spinner,
  useSwipeableViews,
  CloseDialogButton,
  Typography,
  Stack,
  tokens,
} from '@cast/design-system';

type EnablingSlideProps = {
  onClose: () => void;
};

export const EnablingSlide = ({ onClose }: EnablingSlideProps) => {
  const swipeableViewsCtx = useSwipeableViews();

  return (
    <Stack position="relative" data-testid="enabling-slide">
      <CloseDialogButton onClose={onClose} />
      <DialogContent>
        <Stack direction="row" gap={12}>
          <Spinner color="secondary" size={32} />
          <Stack gap={4}>
            <Typography variant="h6">Extending cluster</Typography>
            <Typography variant="P12R" color="textSecondary">
              Closing this dialog will not affect the process.
            </Typography>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions
        sx={{
          py: 16,
          borderTop: tokens.theme.border.structural.neutralSubtle,
          justifyContent: 'space-between',
        }}
      >
        <Button
          testId="back-step-button"
          variant="ghost"
          size="md"
          startIcon={<Icons.ArrowLeft />}
          onClick={() => swipeableViewsCtx?.goToPreviousSlide()}
        >
          Back
        </Button>
        <Button testId="close-button" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Stack>
  );
};
